import type { FaireProductEntity } from "../../entity_types/product";

export const p_vpjrcczhsu: FaireProductEntity = {
  token: "p_vpjrcczhsu",
  type: "product",
  name: 'Small Strawberry Planter-5"D',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/ad5d2e3d1d3acfcc7ea733fecc49f238eabfed82d69e8aa939981cb6ab60b682.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6de0c51367f012cf0b59a7ef9aeb56df175c5a14d049b49d44178b4a91ee581e.jpeg",
    "https://cdn.faire.com/fastly/78de23f33e0095fabdf25ca0012f8be16b51191aeca98e94447eddfe6f5c5107.jpeg",
    "https://cdn.faire.com/fastly/3120e13df309942a8b7d3c29ead73bdd7b38814b3da5df34695484f914338638.jpeg",
    "https://cdn.faire.com/fastly/7c8113b030cb6cf7c1f51d7f8de9b369866735957d9cbe180f62d38d8aa481c8.jpeg",
  ],
  priceDollars: 14,
  description:
    "Make your decor more fruitful with this fun Small Strawberry Planter. Crafted out of cement and painted light red with delightful seed-like details, this planter is the perfect complement to your favourite succulents, flowers or blooms. Other sizes available soon.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:09.127Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
